import { useQuery } from "react-query";
import { Customer } from "../models";
import { ICustomer } from "../types";
import { useCache } from "../context/CacheContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { useUserSession } from "../context/UserContext";
import { listCustomers } from "../data/api/customers";
import { queryKeys } from "../data/queryKeys";

/**
 * Workspace customers, read through the REST API (previously a direct Firestore
 * query). The query key, cache-key invalidation and `Customer[]` instance
 * return shape are preserved, so existing consumers — including
 * `WorkspaceDataProvider` — and `updateCacheKey()` keep working unchanged.
 */
const useCustomers = (workspaceId?: string) => {
  const { cacheKey } = useCache();
  const { activeWorkspace } = useWorkspace();
  const { userSession, isAuthenticated } = useUserSession();
  const resolvedWorkspaceId = workspaceId ?? activeWorkspace?.workspaceId ?? "";
  const token = userSession?.token?.accessToken;

  return useQuery<Customer[], Error>(
    queryKeys.customers(cacheKey, resolvedWorkspaceId),
    async () => {
      const customers = await listCustomers(token as string, resolvedWorkspaceId);
      return customers.map((customer: ICustomer) => new Customer(customer));
    },
    {
      enabled: !!token && !!resolvedWorkspaceId && isAuthenticated(),
    },
  );
};

export default useCustomers;
